export default __webpack_public_path__ + "static/media/home-violet.133364c4.svg";